export function formataEndereco(endereco: string): boolean {
  return false;
}

export function formataCNPJ(cnpj: string): boolean {
  return false;
}

export function formatCurrency(value: string | number): string {
  let number: number;

  if (typeof value === 'string') {
    const cleaned = value.trim();

    // Handle Brazilian format like "R$ 5.000,00"
    if (
      cleaned.includes('R$') ||
      (cleaned.includes(',') && cleaned.includes('.'))
    ) {
      number = Number(
        cleaned.replace('R$', '').replace(/\./g, '').replace(',', '.').trim(),
      );
    } else {
      // Assume it's a plain number string like "50000.00"
      number = Number(cleaned);
    }
  } else {
    number = value;
  }

  if (Number.isNaN(number)) return 'R$ 0,00';

  return number.toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
